import { useEffect } from "react";
import "./Loader.css";
import { getTranslations, detectPreferredLocale } from "../../i18n/i18n";

const Loader = ({
	theme = "light",
	translate: propTranslate,
	locale: propLocale,
	loadingTextKey,
	fullscreen = true,
}) => {
	// Use provided translate function or create one based on detected/provided locale
	let translate = propTranslate;

	if (!translate) {
		const detectedLocale = propLocale || detectPreferredLocale();
		const translations = getTranslations(detectedLocale);
		translate = translations.translate;
	}

	const textKeyToUse = loadingTextKey || "global.appLoading";

	// Block scroll when loader is fullscreen
	useEffect(() => {
		if (fullscreen) {
			document.documentElement.classList.add("scroll-blocked");
		}

		return () => {
			if (fullscreen) {
				document.documentElement.classList.remove("scroll-blocked");
			}
		};
	}, [fullscreen]);

	return (
		<div className={`loader-container ${theme} ${!fullscreen ? "inline" : ""}`}>
			<div className="loader" role="status" aria-label="Loading...">
				<div className="loader-dot" />
				<div className="loader-dot" />
				<div className="loader-dot" />
			</div>
			<p className="loader-text">{translate(textKeyToUse)}</p>
		</div>
	);
};

export default Loader;
